export const lightTheme = {
    body: '#E3E3E0',
    text: '#030303',
    toggleBorder: '#FFF',
    mainbackground: '#808080',
    background:'#FFF',
    lightback:'#FAFAFA',
    text2:"#FF5700",
}
export const darkTheme = {
    lightback:'#272729',
    mainbackground: '#363537',
    background:'#black',
    body: '#030303',
    text: '#FAFAFA',
    toggleBorder: '#6B8096',
}